import React, { PropTypes } from 'react';
import Slider from 'react-slick';

import { breakpointMD, breakpointLG } from '../../base-styles/vars';

import { PrevArrow, NextArrow } from './components/Arrow';

import styles from './styles.css'; // eslint-disable-line no-unused-vars

// Breakpoint settings are string vars for min-width e.g. '768px'
// Slider is looking for ints for max-widths, e.g. 767
const breakpoints = {
  SM: parseInt(breakpointMD.replace('px', ''), 10) - 1,
  MD: parseInt(breakpointLG.replace('px', ''), 10) - 1,
};

/**
 * Carousel presentational component.
 * Configures defaults and styles React Slick slider.
 **/
const Carousel = ({ children, settingsSM, settingsMD, ...props }) => {
  const responsiveSettings = [];
  if (settingsSM) {
    responsiveSettings.push({
      breakpoint: breakpoints.SM,
      settings: settingsSM,
    });
  }
  if (settingsMD) {
    responsiveSettings.push({
      breakpoint: breakpoints.MD,
      settings: settingsMD,
    });
  }
  return (
    <div className="carouselComponent">
      <Slider
        lazyLoad
        infinite={false}
        responsive={responsiveSettings}
        speed={500}
        nextArrow={<NextArrow className="slick-disabled" />}
        prevArrow={<PrevArrow className="slick-disabled" />}
        {...props}
      >
        {children}
      </Slider>
    </div>
  );
};

Carousel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * Object of settings to use up to SM breakpoint.
   */
  settingsSM: PropTypes.shape(),
  /**
   * Object of settings to use up to MD breakpoint.
   */
  settingsMD: PropTypes.shape(),
};

Carousel.defaultProps = {
  settingsSM: undefined,
  settingsMD: undefined,
};

export default Carousel;



// WEBPACK FOOTER //
// ./app/src/components/Carousel/index.jsx